import { render, staticRenderFns } from "./tariffBinllingList.vue?vue&type=template&id=19d474cc&scoped=true&"
import script from "./tariffBinllingList.vue?vue&type=script&lang=ts&"
export * from "./tariffBinllingList.vue?vue&type=script&lang=ts&"
import style0 from "./tariffBinllingList.vue?vue&type=style&index=0&id=19d474cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d474cc",
  null
  
)

export default component.exports